import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import CloseButton from '@/components/close-button'
import { createModal, useModalize } from '@/components/modalize'
import { select } from '@/store'
import { breakpoints } from '@/styles'
import ContractList from './contract-list'

const Wrapper = styled.div`
  padding: 32px 55px 0;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: ${breakpoints.phoneMax}) {
    padding: 40px 35px 0;
  }
`

const EmptyHistoryText = styled.div`
  padding-bottom: 30px;
`

const ContractHistoryModal = ({ listingId, history }) => {
  const { t } = useTranslation()
  const { close } = useModalize()

  const groupListingContracts = useSelector(state =>
    select.contract.groupListingContracts(state, { listingId })
  )

  const onNavigate = path => {
    history.push(path)
    close()
  }

  return (
    <Wrapper>
      <CloseButton onClick={close} />
      {!groupListingContracts ? (
        <EmptyHistoryText>
          {t('l.contracts.view.contract_no_history.title', 'No Contract History')}
        </EmptyHistoryText>
      ) : (
        <>
          <ContractList
            contracts={groupListingContracts.signed}
            title={t(
              'l.rental_dashboard.edit.resources_upcoming_contract.title',
              'Upcoming Contract'
            )}
            modalDisplay
            listingId={listingId}
            onNavigate={onNavigate}
          />
          <ContractList
            contracts={groupListingContracts.active}
            title={t(
              'l.rental_dashboard.edit.resources_current_contract.title',
              'Current Contract'
            )}
            modalDisplay
            listingId={listingId}
            onNavigate={onNavigate}
          />
          <ContractList
            contracts={groupListingContracts.history}
            title={t('l.rental_dashboard.edit.resources_past_contract.title', 'Past Contract')}
            modalDisplay
            listingId={listingId}
            onNavigate={onNavigate}
          />
        </>
      )}
    </Wrapper>
  )
}

export const show = createModal(ContractHistoryModal)
